export enum UserRoles {
    SuperAdmin = 'SUPER_ADMIN',
    Admin = 'ADMIN',
    CompanyAdmin = 'COMPANY_ADMIN',
    RestaurantAdmin = "RESTAURANT_ADMIN",
    CompanyEmployee = "COMPANY_EMPLOYEE",
    AdminOverride = "ADMIN_OVERRIDE"
};